@let skillValue = skill();

<rt-box [variant]="'no-padding vertical'">
  <div
    (click)="onClick()"
    class="header"
    layout
    layout-space-between
    layout-align-items-center
    layout-full-width
  >
    <div
      layout
      layout-space-between
      layout-align-items-center
      min-width-0
      layout-full-width
      padding-lr
      padding-tb-small
    >
      <div class="columns" layout-full-width>
        <div layout min-width-0>
          <span
            [rtTooltip]="skillValue.name"
            [rtTooltipEnableWhenTruncated]="true"
            class="skill-name"
            text-bold
            text-darkest
            margin-right-small-x
            >{{ skillValue.name }}</span
          >
        </div>

        <div layout-vertical min-width-0 padding-right-small-x>
          <rt-job-skill-scale-rating
            [rating]="skillValue.summaryRating"
            [status]="skillValue.status"
          />
        </div>

        <div layout layout-align-items-center layout-wrap>
          <rt-job-skill-summary-badge [status]="skillValue.status" margin-right-small-x />
          @if (skillValue.mixedTeamFeedback) {
            <rt-job-skill-summary-badge [mixedTeamFeedback]="true" />
          }
        </div>
      </div>

      <div class="icon-container" margin-left-small-xx>
        <rt-icon [name]="isCollapsed() ? 'expand-more' : 'expand-less'" />
      </div>
    </div>
  </div>

  @if (!isCollapsed()) {
    <rt-job-skill-ratings
      [skillRatings]="skillValue.proficiencyRatings"
      [status]="skillValue.status"
    />
  }
</rt-box>
